//export const baseUrl = 'http://192.168.70.2:8001';
// export const baseUrl = 'http://192.168.70.2:8000';
//axios.defaults.baseURL = process.env.REACT_APP_API_URL;
//export const baseUrl = 'http://192.168.70.3:8001';
//export const baseUrl = 'http://192.168.70.3:80';
export const baseUrl = 'https://npfx-market.com';

// export const baseUrl = 'http://localhost:7073';
